// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"18":"c0a1fcb5","77":"ce713ea6","282":"2f753736","447":"81fc86af","622":"4f7b02ad","825":"73cfe1c3","829":"83230acf"}[chunkId] + ".chunk.css";
};